import { render, staticRenderFns } from "./authPic.vue?vue&type=template&id=74a9b18b"
import script from "./authPic.vue?vue&type=script&lang=js"
export * from "./authPic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports